module.exports = "<svg viewBox=\"0 0 23 16\" xmlns=\"http://www.w3.org/2000/svg\"><title>Check Mark</title><path d=\"M8.5 11.64L19.7.44a1.5 1.5 0 1 1 2.12 2.12L9.81 14.57c-.034.036-.07.07-.108.1a1.5 1.5 0 0 1-2.258.156L1.19 8.57a1.5 1.5 0 1 1 2.12-2.12l5.19 5.19z\" id=\"color\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/images/icons/check-mark-icon.svg
// module id = 0WCR
// module chunks = 89